import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { FulfillmentOrderProcessingService } from 'common/data';

class FulfillmentOrderProcessingStore extends BaseStore {
	constructor(rootStore) {
		super(new FulfillmentOrderProcessingService(rootStore.app.baasic.apiClient));
	}

	@action
	createFulfillmentShipment = async (id, sourceOfChange, updateAndCreatePrintJob) => {
		const response = await this.service.createFulfillmentShipment(id, sourceOfChange, updateAndCreatePrintJob);
		this.item = response;
		return this.item.data;
	};

	@action
	createFulfillmentShipmentBulk = async (params, sourceOfChange, updateAndCreatePrintJob) => {
		const response = await this.service.createFulfillmentShipmentBulk(params, sourceOfChange, updateAndCreatePrintJob);
		this.item = response;
		return this.item.data;
	};
}

export default FulfillmentOrderProcessingStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderProcessingStore.js